import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

export function useFreePromotionFulfillment() {
	const { data } = useStarterDashboardV2PageData();
	const freePromotions = data.petition.freePromotions ?? [];
	const autoFreePromotion = freePromotions.find((promotion) => promotion.sourceLocation === 'auto_free_promotion');
	const signatures = autoFreePromotion?.stats?.signatureCount ?? 0;
	const signaturesLocalized = autoFreePromotion?.stats?.signatureCountLocalized ?? 0;

	return {
		data: { signatures, signaturesLocalized },
	};
}
